import axios from "axios";
import {getMsisdn} from './api';

const api = axios.create({
  baseURL: getMsisdn,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;